// extracted by mini-css-extract-plugin
module.exports = {"image_slide":"Member_image_slide__1t-h1","image":"Member_image__2BVTI","name":"Member_name__28Rp3","quote":"Member_quote__MjQSL"};